import { render, staticRenderFns } from "./BulmaSnackbar.vue?vue&type=template&id=e2eb5a72"
import script from "./BulmaSnackbar.vue?vue&type=script&lang=js"
export * from "./BulmaSnackbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports